module.exports = __webpack_public_path__ + "static/media/Artboard21.e462fa99.png";